import { authStrategiesMap, errorStrategiesMap } from '../apiClient/index.js';
import ApiClientBuilder from '../apiClient/ApiClientBuilder.js';
import AuthStrategy from '../enums/AuthStrategyEnum.js';
export { default as AuthStrategy } from '../enums/AuthStrategyEnum.js';

const getAuthStrategy = authConfig => {
  const AuthStrategyClass = authStrategiesMap[authConfig?.strategy || AuthStrategy.DEFAULT];
  let authConfigOptions = authConfig?.options;

  // TODO: Remove this if statement once the deprecated urls config is removed
  if (authConfig?.strategy === AuthStrategy.NP_TOKEN && !authConfig.options && authConfig.urls?.authPath && authConfig.urls?.loginPath) {
    authConfigOptions = {
      authPath: authConfig.urls.authPath,
      loginPath: authConfig.urls.loginPath
    };
  }
  return new AuthStrategyClass(authConfigOptions);
};
const getErrorNormalizationStrategy = errorConfig => {
  const ErrorNormalizationStrategyClass = errorStrategiesMap[errorConfig?.strategy || 'DEFAULT'];
  return new ErrorNormalizationStrategyClass();
};

/**
 * Provides utility functions for interacting with APIs. It gets the utilities based on params like AuthStrategy
 * @param {APIConfig} [config={}] - The configuration to interact with the API. Includes the AuthStrategy and params to authenticate the request
 * @returns {Object} {fetcher} - An object containing the utilities functions like fetcher function.
 */
function ApiUtilities() {
  let {
    authConfig,
    errorConfig
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const SelectedAuthStrategy = getAuthStrategy(authConfig);
  const SelectedErrorNormalizingStrategy = getErrorNormalizationStrategy(errorConfig);
  const clientApi = new ApiClientBuilder().withAuthStrategy(SelectedAuthStrategy).withErrorNormalizingStrategy(SelectedErrorNormalizingStrategy).build();
  const fetcher = async (restMethod, endpoint, dataAndConfig) => clientApi.request({
    ...dataAndConfig,
    method: restMethod,
    url: endpoint
  });
  return {
    fetcher
  };
}

export { ApiUtilities as default };
//# sourceMappingURL=index.js.map
